module.exports = __webpack_public_path__ + "img/loginQuoteImage06.39f5045d.webp";